var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-dialog"},[_c('span',{on:{"click":function($event){return _vm.openDialog()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }